import { createStore } from 'vuex'
import product from './modules/product';
import RequisitionProduct from './modules/product/RequisitionProducts';
import cart from './modules/cart';
import prescriptionSaleCart from './modules/cart/prescription-sale';
import login from './modules/login';
import UserMenuAndPermissions from './modules/user_menu_and_permissions';
import createPersistedState from "vuex-persistedstate";
export default createStore({
  modules: {
    product,
    RequisitionProduct,
    cart,
    prescriptionSaleCart,
    login,
    UserMenuAndPermissions,
  },
  plugins: [createPersistedState()],
})